import { createDefaultContext } from "@imi/ui/helpers/createDefaultContext.js";
import { createContext } from "react";

export type FeatureFlag = {
  enabled: boolean;
  name: string;
};

type FeatureFlagsContextType = {
  flags: FeatureFlag[];
  isFeatureEnabled: (...flags: string[]) => boolean;
};

export const FeatureFlagsContext = createContext<FeatureFlagsContextType>(
  createDefaultContext(),
);
